export const ACCOUNT_NUMBER_REGEX = /^$|^[1-7]\d{0,7}$|^(?!445)[0123489a-zA-Z][A-Za-z0-9]{0,11}$/;
export const ACCOUNT_NUMBER_MAX_LENGTH = 12;
